
import { hasMapEditorPermission } from '@/micro-app/bridge';

/**
 * 校验两个picker时间区间是否有重叠
 * @param {Object} source 对比项
 * @param {Object} current 被对比项
 * @return {boolean}
 */
export const validatePickerItem = (source: any, current: any) => {
  if (!source.value || !current.value) {
    return false;
  }
  const [startTimeStr, endTimeStr] = source.value;
  const formatStart = formatDayTime(startTimeStr);
  const formatEnd = formatDayTime(endTimeStr);
  const [start, end] = current.value;
  const formatStartNum = formatDayTime(start);
  const formartEndNum = formatDayTime(end);
  const hasCross =
    (formatStart >= formatStartNum && formatStart <= formartEndNum) ||
    (formatEnd >= formatStartNum && formatEnd <= formartEndNum) ||
    (formatStart <= formatStartNum && formatEnd >= formartEndNum);
  return hasCross;
};

/**
 * 形如12:02的时间字符串
 * @param {string} time 时间字符串
 * @return {number}
 */
export const formatDayTime = (time: string) => {
  if (typeof time !== 'string') {
    return -1;
  }
  const [hours, minutes] = time?.split(':') || [];
  return parseInt(minutes) * 60 + parseInt(hours) * 3600;
};

export const formateTimeLimit = (time: string) => {
  if (typeof time !== 'string') {
    return [
      {
        id: 0,
        value: null,
        errorMes: '请设置每天生效时间',
      },
    ];
  }
  const timeArr = time.split('|');
  return timeArr.map((t: any, i: number) => {
    const arr = t.split('-');
    return {
      id: i,
      value: arr,
      errorMes: null,
    };
  });
};

export function debounce(fn: any, wait: number = 50) {
  let timer: any = null;
  return function (..._args: any) {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      fn(..._args);
    }, wait);
  };
}
export const getPermissionById = (id: string) => hasMapEditorPermission(id);

export const isEmpty = (param: any) => {
  if (Array.isArray(param) || typeof param === 'string') {
    return param.length === 0;
  }
  return true;
};
